const FeatureFlags = {
  MY: {
    login: {
      line: false,
      mobile: true
    },
    registration: {
      requirePassword: true
    },
    homepage: {
      logoImageSize: 'contain'
    },
    availableCountries: ['MY', 'SG', 'ID', 'PH', 'TH', 'IN', 'DE'],
    rate: {
      share: {
        line: false,
        whatsapp: true
      }
    }
  },
  TH: {
    login: {
      line: true,
      mobile: false
    },
    registration: {
      requirePassword: false
    },
    homepage: {
      logoImageSize: 'cover'
    },
    availableCountries: ['MY', 'PH', 'TH', 'IN', 'SG', 'ID', 'DE'],
    rate: {
      share: {
        line: true,
        whatsapp: true
      }
    }
  },
  PH: {
    login: {
      line: false,
      mobile: true
    },
    registration: {
      requirePassword: true
    },
    homepage: {
      logoImageSize: 'contain'
    },
    availableCountries: ['MY', 'PH', 'TH', 'IN', 'SG', 'ID', 'DE'],
    rate: {
      share: {
        line: false,
        whatsapp: true
      }
    }
  },
  TW: {
    login: {
      line: true,
      mobile: false
    },
    registration: {
      requirePassword: false
    },
    homepage: {
      logoImageSize: 'cover'
    },
    availableCountries: ['MY', 'PH', 'TH', 'IN', 'SG', 'ID'],
    rate: {
      share: {
        line: true,
        whatsapp: true
      }
    }
  }
};

export default FeatureFlags;
